/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import type { Component, Ref } from 'vue'

type ImportType = { default: unknown }
type ComponentFunction = (...args: any) => any
type ComponentValues = null | undefined | Component | [Component] | [] | ImportType | ComponentFunction
type GetInstaceType = abstract new (...args: any) => any

type RefObjectEntry2<T extends ComponentValues> = T extends undefined
  ? HTMLElement
  : T extends GetInstaceType
    ? ComponentExposed<T>
    : T extends ImportType
      ? ComponentExposed<T['default']>
      : ComponentExposed<T>

type RefObjectEntry<T extends ComponentValues> = T extends any[] ? RefObjectEntry2<T[0]>[] : RefObjectEntry2<T> | undefined

type RefObject<Refs extends Record<string, ComponentValues>> = {
  [key in keyof Refs]: Ref<RefObjectEntry<Refs[key]>>
}

export function useRefs<Refs extends Record<string, ComponentValues>>(refs: Refs): RefObject<Refs> {
  type Result = RefObject<Refs>
  const holder: Partial<Result> = {}

  function addKey(obj: Record<any, any>, key: string): void {
    obj.__myRefKey = key
  }

  for (const key in refs) {
    const value = refs[key]
    type T = typeof value
    type Res = Result[keyof Result]
    const res = Array.isArray(value) ? ref<T[]>([]) : ref<T>()
    addKey(res, key)
    holder[key] = res as Res
  }

  ;(holder as any).__refs = refs
  return holder as Result
}

type RefObjectEntry3<T extends VueComponent> = T extends GetInstaceType ? ComponentExposed<T> : T

export function useRefsMap<Elem extends VueComponent = HTMLElement, Key extends string | number = string>() {
  const map = new Map<Key, Elem>()

  return {
    map,
    set(key: Key, el: Element | globalThis.ComponentPublicInstance | None | VueComponent) {
      map.set(key, el)
    },
    get(key: Key | None): RefObjectEntry3<Elem> | undefined {
      if (!helpers.isDef(key)) return
      return (map.get(key) || undefined) as RefObjectEntry3<Elem> | undefined
    },
  }
}
